import React, { useEffect, useState } from 'react'
import { Space, Table, Flex } from 'antd';
import Main from '../../../cpn/Main';
import InvoiceTypeEdit from './InvoiceTypeEdit';    
import InvoiceTypeAdd from './InvoiceTypeAdd';
import { useKaipiaolxListQuery } from '../../../store/DianShangYeWuApi';
import InvoiceTypeDel from './InvoiceTypeDel';
function InvoiceTypeList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useKaipiaolxListQuery({kplx_qy_id:qy_id,});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {kplx_id:key,kplx_name,kplx_uname,kplx_ctime} = item;                  
                    return item = {key,kplx_name,kplx_uname,kplx_ctime}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.yh_ctime;
                    let bTimeString = b.yh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'kplx_name',           
            title: '名称',            
            dataIndex: 'kplx_name',
        },              
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space align='center' size='middle'>
                        <InvoiceTypeEdit
                            kplx_id={record.key} 
                            kplx_name={record.kplx_name} 
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                        />
                        <InvoiceTypeDel
                            kplx_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/InvoiceTypeList']}>                       
            <Flex>
                <InvoiceTypeAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className="custom-table"
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default InvoiceTypeList
